module.exports = __webpack_public_path__ + "static/media/internet.4b36c8a8.png";